import BaseComponentController from "./base_component_controller"
import { computePosition, autoUpdate, offset, flip, shift, arrow } from "@floating-ui/dom"
import { enter, leave } from "../../../../design_system/transitions"

export default class extends BaseComponentController {
  static targets = ["trigger", "content", "arrow"]

  static values = {
    placement: { type: String, default: "top" },
    offset: { type: Number, default: 8 },
    arrowBorderClasses: { type: Object, default: {} },
    interactive: { type: Boolean, default: false }
  }

  connect() {
    this.updatePosition = this.updatePosition.bind(this)
    this.currentElementMouseMove = null

    if(this.interactiveValue) {
      this.mouseMoveTimeout = null
    }

    document.addEventListener('mousemove', e => {
      this.currentElementMouseMove = document.elementFromPoint(e.clientX, e.clientY)
    }, { passive: true })
  }

  toggle() {
    if (!this.hasContentTarget) return
    this.contentTarget.classList.contains("hidden") ? this.show() : this.hide()
  }

  show() {
    if (!this.hasContentTarget) return
    this.updatePosition()
    enter(this.contentTarget)
    this.cleanup = autoUpdate(this.element, this.contentTarget, this.updatePosition)
  }

  hide() {
    if (!this.hasContentTarget) return
    leave(this.contentTarget)

    if (this.cleanup) {
      this.cleanup()
      this.cleanup = null
    }
  }

  handleMouseLeave(event) {
    if (this.interactiveValue) {
      clearTimeout(this.mouseMoveTimeout)

      this.mouseMoveTimeout = setTimeout(() => {
        if (this.element.contains(this.currentElementMouseMove) &&
          (this.currentElementMouseMove.closest('[data-design-system--popover-component-target="content"]') ||
            this.currentElementMouseMove.closest('[data-design-system--popover-component-target="trigger"]'))) {
          return
        }

        this.hide()
      }, 50)
    } else {
      this.hide()
    }
  }

  updatePosition() {
    computePosition(this.element, this.contentTarget, {
      placement: this.placementValue,
      middleware: [offset(this.offsetValue), flip(), shift(), arrow({ element: this.arrowTarget })]
    }).then(({ x, y, placement, middlewareData }) => {
      Object.assign(this.contentTarget.style, { left: `${x}px`, top: `${y}px` })

      const basePlacement = placement.split("-")[0]
      const staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right",
      }[basePlacement]

      if (middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = middlewareData.arrow
        const sides = ['top', 'right', 'bottom', 'left']
        sides.forEach(side => this.arrowTarget.classList.remove(...this.arrowBorderClassesValue[side]))

        Object.assign(this.arrowTarget.style, {
          left: arrowX != null ? `${arrowX}px` : "",
          top: arrowY != null ? `${arrowY}px` : "",
          right: "",
          bottom: "",
          [staticSide]: "-0.4rem"
        })

        const borderClasses = this.arrowBorderClassesValue[staticSide]
        if (borderClasses) {
          this.arrowTarget.classList.add(...borderClasses)
        }
      }
    })
  }
}
